import { routerApolloClient } from '@/shared/graphql/client'
import { useExplorerStore } from '@/features/explorer/store'
import { addPendingRemovalItems } from '@/features/explorer/utils/localExplorerItems'

export function removeItemsFromExplorerCache(ids: string[]) {
  const explorerStore = useExplorerStore()
  const folderId = explorerStore.currentFolder?.id
  if (!folderId) return

  addPendingRemovalItems(folderId, ids)

  routerApolloClient.cache.modify({
    id: routerApolloClient.cache.identify({
      __typename: 'Folder',
      id: folderId,
    }),
    fields: {
      items(existing, { readField }) {
        return {
          ...existing,
          edges: existing.edges.filter((edgeRef: unknown) => {
            const nodeRef = readField('node', edgeRef)
            const nodeId = readField('id', nodeRef)
            return !ids.includes(nodeId as string)
          }),
        }
      },
      totalFiles(existing: number) {
        return Math.max(0, existing - ids.length)
      },
    },
  })
}

export function renameFolderInExplorerCache(folderId: string, newName: string) {
  routerApolloClient.cache.modify({
    id: routerApolloClient.cache.identify({
      __typename: 'Folder',
      id: folderId,
    }),
    fields: {
      name() {
        return newName
      },
    },
  })
}

export function updateFileInExplorerCache(
  fileId: string,
  fields: Record<string, unknown>
) {
  routerApolloClient.cache.modify({
    id: routerApolloClient.cache.identify({
      __typename: 'File',
      id: fileId,
    }),
    fields: Object.fromEntries(
      Object.entries(fields).map(([key, value]) => [key, () => value])
    ),
  })
}
